import type {
  CoverageMetricThresholdGroup,
  MetricThresholdGroup,
  ProjectMetricThresholds,
} from './dtos/core.projects';

const buildTestThresholdGroup = (options: {
  averageDurationTarget: number;
  averageDurationWarn: number;
  flakeScoreTarget: number;
  flakeScoreWarn: number;
  frequencyTarget: number;
}): MetricThresholdGroup => ({
  passRate: { target: 90, warn: 75, direction: 'higherBetter' },
  frequency: {
    target: options.frequencyTarget,
    warn: 0.14285714285714285,
    direction: 'higherBetter',
    targetUnit: 'weeks',
    warnUnit: 'weeks',
  },
  avgDuration: {
    target: options.averageDurationTarget,
    warn: options.averageDurationWarn,
    direction: 'lowerBetter',
    targetUnit: 'minutes',
    warnUnit: 'minutes',
  },
  flakeScore: {
    target: options.flakeScoreTarget,
    warn: options.flakeScoreWarn,
    direction: 'lowerBetter',
  },
  mttf: { target: 1, warn: 3, direction: 'lowerBetter' },
  greenTime: { target: 3, warn: 1, direction: 'higherBetter' },
});

const buildCoverageThresholdGroup = (): CoverageMetricThresholdGroup => ({
  line: { target: 90, warn: 75, direction: 'higherBetter', enabled: true },
  function: { target: 90, warn: 75, direction: 'higherBetter', enabled: true },
  branch: { target: 85, warn: 70, direction: 'higherBetter', enabled: true },
  statement: { target: 90, warn: 75, direction: 'higherBetter', enabled: true },
});

export const defaultProjectMetricThresholds: ProjectMetricThresholds = {
  suites: buildTestThresholdGroup({
    averageDurationTarget: 300,
    averageDurationWarn: 600,
    flakeScoreTarget: 10,
    flakeScoreWarn: 25,
    frequencyTarget: 0.42857142857142855,
  }),
  executionRuns: buildTestThresholdGroup({
    averageDurationTarget: 600,
    averageDurationWarn: 900,
    flakeScoreTarget: 10,
    flakeScoreWarn: 25,
    frequencyTarget: 0.42857142857142855,
  }),
  tests: buildTestThresholdGroup({
    averageDurationTarget: 120,
    averageDurationWarn: 300,
    flakeScoreTarget: 5,
    flakeScoreWarn: 25,
    frequencyTarget: 0.42857142857142855,
  }),
  pipelines: buildTestThresholdGroup({
    averageDurationTarget: 900,
    averageDurationWarn: 1200,
    flakeScoreTarget: 25,
    flakeScoreWarn: 50,
    frequencyTarget: 0.2857142857142857,
  }),
  stages: buildTestThresholdGroup({
    averageDurationTarget: 900,
    averageDurationWarn: 1200,
    flakeScoreTarget: 25,
    flakeScoreWarn: 50,
    frequencyTarget: 0.2857142857142857,
  }),
  jobs: buildTestThresholdGroup({
    averageDurationTarget: 600,
    averageDurationWarn: 900,
    flakeScoreTarget: 25,
    flakeScoreWarn: 50,
    frequencyTarget: 0.42857142857142855,
  }),
  coverageRuns: buildCoverageThresholdGroup(),
  directories: buildCoverageThresholdGroup(),
  files: buildCoverageThresholdGroup(),
};
